import { initAnimations } from './animations.js';

initAnimations();
